import { FormControl, FormHelperText, InputLabel } from '@mui/material'
import clsx from 'clsx'
import { useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import './BaseCreatableSelect.scss'

interface IBaseCreatableSelect {
    options?: any
    label?: string
    value?: any
    onChange?: any
    isCreatable?: boolean
    error?: boolean
    helperText?: string
    fullWidth?: boolean
    className?: string
    disabled?: boolean
    isLoading?: boolean
}

const BaseCreatableSelect = (props: IBaseCreatableSelect) => {
    const {
        options = [],
        label = 'Select ...',
        value,
        onChange,
        isCreatable = false,
        helperText,
        error,
        fullWidth,
        className,
        disabled,
        isLoading,
    } = props

    // async select
    const [focus, setFocus] = useState(false)
    const [validCreate, setValidCreate] = useState(false)

    return (
        <FormControl
            className={clsx(
                'async-form-control',
                className,
                disabled && 'disabled-select'
            )}
            fullWidth={fullWidth}
            error={error}
        >
            <InputLabel
                htmlFor="my-input"
                className={clsx(focus || value ? 'MuiInputLabel-shrink' : null)}
            >
                {label || 'Select ...'}
            </InputLabel>
            <CreatableSelect
                options={options?.map((i: any) => ({ ...i, label: i?.name }))}
                value={
                    options
                        ?.map((i: any) => ({ ...i, label: i?.name }))
                        .find((i: any) => i?.value === value) ||
                    value ||
                    null
                }
                onChange={(e: any) => {
                    if (e?.value === value) return

                    // eslint-disable-next-line no-underscore-dangle
                    if (e?.__isNew__) return onChange(e)
                    return onChange(e?.value)
                }}
                isClearable={value}
                className={clsx('creatable-component')}
                classNamePrefix="creatable"
                placeholder=""
                onFocus={(evt: any) => {
                    setFocus(evt?.type === 'focus')
                }}
                onBlur={(evt: any) => {
                    setFocus(evt?.type !== 'blur')
                }}
                isLoading={isLoading}
                isDisabled={disabled}
                onInputChange={(inputValue: string, actionMeta: any) => {
                    if (actionMeta?.action === 'input-change' && inputValue) {
                        return setValidCreate(true)
                    }
                    return setValidCreate(false)
                }}
                isValidNewOption={() => isCreatable && validCreate}
            />
            <FormHelperText id="my-helper-text">{helperText}</FormHelperText>
        </FormControl>
    )
}

export default BaseCreatableSelect
